import { withI18n } from '@lingui/react'
import { useState } from 'react'

import { isEmpty } from 'shared/utils/objectUtils'
import updateCustomerPreferredLanguage from 'shared/utils/updateCustomerPreferredLanguage'
import at from 'views/assets/images/flags/flag-austria.svg'
import fr from 'views/assets/images/flags/flag-france.svg'
import de from 'views/assets/images/flags/flag-germany.svg'
import it from 'views/assets/images/flags/flag-italy.svg'
import es from 'views/assets/images/flags/flag-spain.svg'
import IconCaretDown from 'views/components/atoms/Icon/IconCaretDown'
import IconCaretUp from 'views/components/atoms/Icon/IconCaretUp'
import { getLanguagesOptions } from 'views/components/organisms/LanguageSwitcher/utils'
import { i18nType } from 'views/utils/propTypes'
import {
  usePageProperties,
  usePublicConfig,
} from 'views/utils/shopAndRuntimeConfigUtils'

import './LanguageSwitcherMobile.scss'

const flags = {
  fr,
  de,
  at,
  it,
  es,
}

const LanguageSwitcherMobile = ({ i18n }) => {
  const { language } = usePublicConfig()
  const { alternativeUrls = {} } = usePageProperties()

  const shopLanguages = getLanguagesOptions(language, alternativeUrls, i18n)
  const currentLanguage = shopLanguages.find(language => language.selected)

  const [isOpen, setIsOpen] = useState(false)
  const toggleLanguageMenu = () => {
    setIsOpen(!isOpen)
  }

  if (isEmpty(alternativeUrls)) {
    return null
  }

  return (
    <div className="o-LanguageSwitcherMobile">
      <div className="o-LanguageSwitcherMobile__item">
        <button
          className="
            a-Button
            a-Button--BlockMenu
            a-Button--BlockMenu-light
            u-display--block
            a-link--neutral
            u-vertical-align--middle
            o-LanguageSwitcherMobile__link"
          onClick={toggleLanguageMenu}
        >
          <div className="u-vertical-align--middle l-flex">
            <div className="l-col--3-of-12">
              <span className="u-font-weight--bold u-padding-small--right">
                {i18n._('general.languageSwitch.language')}
              </span>
            </div>
            <div className="l-col--7-of-12">
              <div className="u-display--inline-block u-margin--right u-vertical-align--middle">
                <img
                  className="o-LanguageSwitcherMobile__flag--rounded "
                  src={flags[currentLanguage.code]}
                  alt=""
                />
              </div>
              <span className="u-vertical-align--middle u-font-weight--bold">
                {currentLanguage.text}
              </span>
            </div>
            <div className="o-LanguageSwitcherMobile__icon o-LanguageSwitcherMobile__icon--rounded l-col--2-of-12">
              {isOpen ? <IconCaretUp /> : <IconCaretDown />}
            </div>
          </div>
        </button>
      </div>
      {isOpen && (
        <ul className={`o-LanguageSwitcherMobile__list a-list-reset`}>
          {shopLanguages.map(
            language =>
              language !== currentLanguage && (
                <li
                  key={language.code}
                  className="o-LanguageSwitcherMobile__item"
                >
                  <a
                    href={language.href}
                    data-lang={language.code}
                    className="
                    u-display--block
                    a-link--neutral
                    u-vertical-align--middle
                    o-LanguageSwitcherMobile__link"
                    onClick={() =>
                      updateCustomerPreferredLanguage(language.code)
                    }
                  >
                    <div className="l-grid">
                      <div className="l-grid__item l-col--3-of-12"></div>
                      <div className="l-grid__item l-col--8-of-12">
                        <div className="u-display--inline-block u-margin--right u-vertical-align--middle">
                          <img
                            className="o-LanguageSwitcherMobile__flag--rounded "
                            src={flags[language.code]}
                            alt=""
                          />
                        </div>
                        <span className="u-vertical-align--middle u-font-weight--bold">
                          {language.text}
                        </span>
                      </div>
                    </div>
                  </a>
                </li>
              )
          )}
        </ul>
      )}
    </div>
  )
}

LanguageSwitcherMobile.propTypes = {
  i18n: i18nType.isRequired,
}

// TODO Remove if unused after the CH shop migrated to Fock
export default withI18n()(LanguageSwitcherMobile)
